import { TenantRegion } from '@etiquetachef/types';

const KEYS: Readonly<Record<TenantRegion, string>> = {
  [TenantRegion.SOUTHAMERICA_EAST1]: 'admin.countries.catalog.region.sa',
  [TenantRegion.EUROPE_WEST1]: 'admin.countries.catalog.region.eu',
};

/**
 * Chave i18n do nome legível de uma região (São Paulo / Bélgica).
 *
 * Origem: #1078 — 2026-10-29 10:20 +0100 (F2 da #960).
 *
 * Usado por: `CountriesTab.tsx` (coluna e filtro Região) e `CountryEditDialog.tsx` (Select).
 */
export function regionLabelKey(region: TenantRegion): string {
  return KEYS[region];
}
